












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Não entende o motivo de estar desalinhado no seu trabalho, na relação com a família ou com a pessoa que você gosta afetivamente e, por isso, está sofrendo?",
  "Está tendo dificuldade de relacionamento com seus filhos, especialmente adolescentes, e não consegue educar, da mesma forma, crianças que possuem idades diferentes?",
  "Já percebeu que tem muito mais a oferecer a este mundo mas não sabe como agir para mudar o rumo da sua vida em diversas áreas?",
  "Acha que não tem sorte, que a vida tem sido cruel contigo e que suas tentativas para transformar seu futuro não atingem o resultado ideal?",
  "Não entende a relação conturbada que está vivendo, mas acredita que é possível melhorar a convivência com seus irmãos, pais, namorado(a) ou cônjuge?",
  "Já tentou de tudo e está muito próximo de se separar ou de largar o emprego/negócio?"
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
